import { css } from '@emotion/react'

export const TabsStyle = css`

    .tab-button {
        border: 1px solid #B5BABE;
        border-top-right-radius: 2px;
        border-top-left-radius: 2px;
        border-bottom: none;
        padding: .8em 1em .5em;
        background: #fff;
        color: #000;
    }

    .tab-button:disabled {
        background: #eee;
        color: var(--cool-gray);
    }


    .tab-button:active {
        outline: 0;
    }

    .tab-box, .tab-box-code {
        padding: 1.5em 1.2em 1.5em;
        border: 1px solid #B5BABE;
        border-radius: .3em;
        border-top-left-radius: 0;
    }


    .tab-box-code > pre {
        background: var(--main-bg);
    }

`